import { db } from "../common/config/Firebase";

export const SET_TASK_SELECTED = 'SET_TASK_SELECTED';
export const SET_TASK_DETAIL_DATA = 'SET_TASK_DETAIL_DATA';
export const SET_TASK_DETAIL_LOADING = 'SET_TASK_DETAIL_LOADING';

export const setTaskSelected = payload => (
    { type: SET_TASK_SELECTED, payload }
);

export const setTaskDetailData = payload => (
    { type: SET_TASK_DETAIL_DATA, payload }
);

const setTaskDetailLoading = payload => (
    { type: SET_TASK_DETAIL_LOADING, payload }
);

const collectionTaskDetail = db.collection('tasksDetail')

export const getTaskDetail = ({ id }) => {
    return (dispatch, getState) => {
        dispatch(setTaskDetailLoading());

        collectionTaskDetail.doc(id).get().then(result => {
            const detail = result.data() ? result.data() : { observations: [] };
            dispatch(setTaskDetailData({ detail }));
        });
    }
}
